module.exports = __webpack_public_path__ + "img/self-management-tools.da959daf.svg";